import { render, staticRenderFns } from "./ApplicantTaxProfile.vue?vue&type=template&id=1d23f5f8&"
import script from "./ApplicantTaxProfile.vue?vue&type=script&lang=js&"
export * from "./ApplicantTaxProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports